import React, { Component } from 'react';
import { useParams } from 'react-router-dom';
import { industryData } from './industryData';
import { Phone, CheckCircle, Star } from 'lucide-react';

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}

class IndustryPage extends Component {
  constructor(props) {
    super(props);
    const { slug } = this.props.params;
    this.state = {
      activeFeature: 0,
      industry: industryData[slug] || null
    };
  }

  componentDidMount() {
    this.featureInterval = setInterval(() => {
      const { industry } = this.state;
      this.setState(prevState => ({
        activeFeature: (prevState.activeFeature + 1) % (industry?.features?.length || 1)
      }));
    }, 4000);
  }

  componentDidUpdate(prevProps) {
  const prevSlug = prevProps.params.slug;
  const currentSlug = this.props.params.slug;

  if (prevSlug !== currentSlug) {
    const newIndustry = industryData[currentSlug] || null;

    this.setState({
      industry: newIndustry,
      activeFeature: 0,
    });
  }
}

  componentWillUnmount() {
    clearInterval(this.featureInterval);
  }

  setActiveFeature = index => this.setState({ activeFeature: index });

  render() {
    const { industry, activeFeature } = this.state;
    if (!industry) return <div className="text-white text-center p-5">Industry not found.</div>;

    return (
      <div className="min-vh-100" style={{ backgroundColor: '#010A1A', color: '#ffffff' }}>
        {/* Banner */}
        <section className="general-banner">
          <div className="container">
            <div className="general-content">
              <h1 className="hero-title orbitron">{industry.title}</h1>
              <p className="hero-subtitle">{industry.subtitle}</p>
            </div>
          </div>
        </section>
       

       

        {/* Challenges */}
        {industry.challenges && (
          <section className="py-5" style={{ backgroundColor: '#1a2332' }}>
            <div className="container">
              <div className="text-center mb-5">
                <h2 className="fw-bold">Industry Challenges</h2>
              </div>
              <div className="row g-4">
                {industry.challenges.map((c, index) => (
                  <div key={index} className="col-md-6">
                    <div className="p-4 d-flex align-items-start gap-3 border rounded" style={{ backgroundColor: '#002C58' }}>
                      <div className="p-3 bg-danger text-white rounded">{c.icon}</div>
                      <div>
                        <h5 className="fw-bold mb-1">{c.title}</h5>
                        <p className="text-secondary mb-0">{c.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* Services */}
        {industry.services && (
          <section className="py-5">
            <div className="container">
              <div className="text-center mb-5">
                <h2 className="fw-bold">Our Services</h2>
              </div>
              <div className="row g-4">
                {industry.services.map((s, index) => (
                  <div key={index} className="col-md-6">
                    <div className="p-4 border rounded" style={{ backgroundColor: '#1a2332' }}>
                      <h5 className="fw-bold mb-2">{s.title}</h5>
                      <p className="text-secondary">{s.description}</p>
                      <ul className="list-unstyled">
                        {s.features.map((f, i) => (
                          <li key={i} className="d-flex align-items-center mb-2">
                            <CheckCircle className="me-2" size={16} style={{ color: '#06b6d4' }} />
                            <span className="text-secondary">{f}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* Features (Optional) */}
        {industry.features && (
          <section className="py-5" style={{ backgroundColor: '#002C58' }}>
            <div className="container">
              <div className="row g-4">
                {industry.features.map((f, index) => (
                  <div
                    key={index}
                    className={`col-md-6 cursor-pointer border rounded p-4 ${
                      activeFeature === index ? 'border-2 border-info' : 'border-1'
                    }`}
                    style={{ backgroundColor: activeFeature === index ? '#1a2332' : '#010A1A' }}
                    onClick={() => this.setActiveFeature(index)}
                  >
                    <div className="d-flex align-items-start gap-3">
                      <div className="p-2 bg-primary text-white rounded">{f.icon}</div>
                      <div>
                        <h5 className="fw-bold mb-2">{f.title}</h5>
                        <p className="text-secondary">{f.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* Testimonials */}
        {/* {industry.testimonials && (
          <section className="py-5">
            <div className="container">
              <div className="text-center mb-5">
                <h2 className="fw-bold">Client Testimonials</h2>
              </div>
              <div className="row g-4">
                {industry.testimonials.map((t, index) => (
                  <div key={index} className="col-md-4">
                    <div className="p-4 border rounded" style={{ backgroundColor: '#1a2332' }}>
                      <div className="d-flex mb-2">
                        {[...Array(t.rating)].map((_, i) => (
                          <Star key={i} size={18} style={{ color: '#fbbf24', fill: '#fbbf24' }} />
                        ))}
                      </div>
                      <p className="text-secondary">"{t.text}"</p>
                      <div>
                        <h6 className="fw-bold mb-0">{t.name}</h6>
                        <small className="text-secondary">{t.company}</small>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )} */}

        {/* CTA */}
        <section className="py-5" style={{ background: 'linear-gradient(135deg, #002C58, #3b82f6)' }}>
          <div className="container text-center">
            <h2 className="fw-bold mb-3">Get a Free Assessment</h2>
            <p className="mb-4">Let our experts show you how we can secure your site and reduce risks immediately.</p>
            <button className="btn btn-light btn-lg d-flex align-items-center justify-content-center gap-2 mx-auto">
              <Phone size={18} /> Call Now: +1 (403) 992-1672
            </button>
          </div>
        </section>
      </div>
    );
  }
}

export default withParams(IndustryPage);
